// extracted by mini-css-extract-plugin
export default {"error":"Signin_error__BUEdz"};